import React, { forwardRef } from 'react';

const MainPage = forwardRef(({ aboutRef, missionRef, joinRef }, ref) => {
    return (
        <>
            <div className="flex pt-12 px-6 md:px-20  items-center justify-center bg-hero md:h-screen overflow-hidden">
                <div className="flex flex-col  gap-6 md:flex-row items-center max-w-8xl">
                    <div className="w-full md:w-1/2 lg:pr-32">
                        <h2 className="text-4xl lg:text-5xl text-center md:text-left text-jfePurple leading-tight font-medium">JOY
                            FOR <br /> Everyone</h2>
                        <h3
                            className="mt-6 md:mt-10 text-md lg:text-xl text-center md:text-left text-gray-700 font-light font-serifs tracking-wider leading-relaxed">
                            Fii alături de noi în misiunea de a aduce sprijin și bucurie copiilor cu situații dificile. Cu toate ca este dedicat în mare parte elevilor de liceu, orice alt doritor este binevenit sa se alăture! Acest program de voluntariat le oferă copiilor ocazia de a petrece timp prețios cu persoane din afara centrului ajutându-i la teme, dezvoltându-le abilitățile și creând amintiri frumoase prin activități interactive și jocuri captivante. În preajma sărbătorilor, le pregătim surprize speciale și cadouri, încercând sa le facem o bucurie într-un mediu care sa îi facă să se simtă apreciați. Alătură-te nouă pentru a aduce o rază de lumină în viețile lor și pentru a le arăta că au pe cineva care le este alături!

                        </h3>

                    </div>
                    <div className="w-full md:w-1/2 flex justify-center md:justify-end">
                        <img alt="" src="coordonatori.jpg" />
                    </div>
                </div>
            </div>
            {/* inceput de about us */}
            <div ref={aboutRef} className="flex pt-12 px-6 md:px-20 items-center justify-center bg-hero md:h-screen overflow-hidden">
                <div className="flex flex-col gap-6 md:flex-row items-center max-w-8xl">

                    <div className="w-full md:w-1/2 flex justify-center md:justify-start">
                        <img alt="" src="about us.jpg" />
                    </div>

                    <div className="w-full md:w-1/2 lg:pl-32">
                        <h2 className="text-4xl lg:text-5xl text-center md:text-left text-jfePurple leading-tight font-medium">Despre<br /> Noi
                        </h2>
                        <h3 className="mt-6 md:mt-10 text-md lg:text-xl text-center md:text-left text-gray-700 font-light font-serifs tracking-wider leading-relaxed">
                            Majoritatea suntem absolvenți sau actuali elevi ai Liceului Teoretic "GRIGORE MOISIL", dar din echipa noastră fac parte și elevi ai altor școli și profesori universitari de la Universitatea Politehnica Timișoara . Colectivul nostru divers ne oferă șansa de a organiza proiecte diferite in fiecare luna!
                        </h3>

                    </div>

                </div>
            </div>
            <div ref={missionRef} className="flex pt-12 px-6 md:px-20  items-center justify-center bg-hero md:h-screen overflow-hidden">
                <div className="flex flex-col  gap-6 md:flex-row items-center max-w-8xl">
                    <div className="w-full md:w-1/2 lg:pr-32">
                        <h2 className="text-4xl lg:text-5xl text-center md:text-left text-jfePurple leading-tight font-medium">MISIUNEA <br /> NOASTRA
                        </h2>
                        <h3
                            className="mt-6 md:mt-10 text-md lg:text-xl text-center md:text-left text-gray-700 font-light font-serifs tracking-wider leading-relaxed">
                            Dorim să facem o schimbare cât de mică atât în viața copiilor, cât și a voluntarilor noștri!
                            Tinerii noștri voluntari relaționează ușor cu copiii find aproximativ la aceeași vârsta.
                            Prin proiectele diverse pe care le organizăm încercăm să subliniem individualitatea copiilor și faptul că pentru noi fiecare dintre ei este important si special!


                        </h3>

                    </div>
                    <div className="w-full md:w-1/2 flex justify-center md:justify-end">
                        <img alt="" src="volutari.jpg" />
                    </div>
                </div>
            </div>
            {/* final about us */}
            <div ref={joinRef} style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                <iframe
                    src="https://docs.google.com/forms/d/e/1FAIpQLScMdReTsSCZP9Uue9cLYKxZoRxURqmZZXpml9NNOg066zSX2A/viewform?embedded=true"
                    className="w-[640px] h-[1502px]"
                    title="Google Forms">Loading…
                </iframe>
            </div>
            <div className="flex pt-12 px-6 md:px-20  items-center justify-center bg-hero md:h-screen overflow-hidden">
                <div className="flex flex-col  gap-6 md:flex-row items-center max-w-8xl">
                    <div className="w-full md:w-1/2 lg:pr-32">
                        <h2 className="text-4xl lg:text-5xl text-center md:text-left text-jfePurple leading-tight font-medium">Multumiri
                        </h2>
                        <h3
                            className="mt-6 md:mt-10 text-md lg:text-xl text-center md:text-left text-gray-700 font-light font-serifs tracking-wider leading-relaxed">
                            Dorim să mulțumim cadrelor didactice din cadrul Liceului Teoretic "GRIGORE MOISIL" și a Universității Politehnica Timișoara fără de care nu ne-am fi putut desfășura activitatea! Totodată, mulțumim tuturor celor care ne au susținut si ne au ajutat cum au putut!
                        </h3>

                    </div>
                    {/* <div className="w-full md:w-1/2 flex justify-center md:justify-end">
                        <img alt="" src="coordonatori.jpg" />
                    </div> */}
                </div>
            </div>
        </>
    )
})
export default MainPage;